import { FloraButton, Flex, Toaster } from '@grupoboticario/flora-react';
import { LocationPinIcon, TwoPiledSquaresIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';
import { Place } from 'domains/reseller-place';
import { copyText } from 'helpers';
import { useTracking } from 'hooks';
import { newRelicMonitoringService } from 'services';

import Styles from '../ResellerPlace.styles';

export const PlaceCard = (place: Place) => {
  const { sendDataToGTM } = useTracking();

  const handleCopy = (text: string) => () => {
    copyText(text)
      .then(() => {
        Toaster.notify({
          kind: 'success',
          description: 'Endereço copiado com sucesso!',
          origin: 'right-top',
        });
        sendDataToGTM({
          event: 'analytics-event',
          event_parameters: {
            event_name: 'callback_copiar_endereco_sucesso',
          },
        });
      })
      .catch((e) => {
        Toaster.notify({
          kind: 'error',
          description: 'Não foi possível copiar o endereço. Tente novamente.',
          origin: 'right-top',
        });
        sendDataToGTM({
          event: 'analytics-event',
          event_parameters: {
            event_name: 'callback_copiar_endereco_error',
            cd_error_message: e.message,
          },
        });
        newRelicMonitoringService.addPageAction('callback_copiar_endereco', {
          cd_interaction_detail: `erro:${e.message}`,
        });
      });
  };

  return (
    <Styles.Card aria-label='endereço do espaço encontrado'>
      <Styles.CardWrapper direction='column' align='flex-start' justify='space-between'>
        <ResponsiveFloraTypography fontSize='bodySmallShort' color='$nonInteractivePredominant'>
          {place.name}
        </ResponsiveFloraTypography>
        <Flex gap='$1'>
          <LocationPinIcon color='$actionableDefault' aria-hidden='true' />
          <Flex direction='column' aria-label={place.fullAddress ?? ''}>
            <ResponsiveFloraTypography
              fontSize='bodySmallShort'
              color='$nonInteractiveAuxiliar'
              aria-hidden
            >
              {place.address?.street}
            </ResponsiveFloraTypography>
            <ResponsiveFloraTypography
              fontSize='bodySmallShort'
              color='$nonInteractiveAuxiliar'
              aria-hidden
            >
              {place.address?.complement}
            </ResponsiveFloraTypography>
            <ResponsiveFloraTypography
              fontSize='bodySmallShort'
              color='$nonInteractiveAuxiliar'
              aria-hidden
            >
              {place.address?.district}
            </ResponsiveFloraTypography>
            <ResponsiveFloraTypography
              fontSize='bodySmallStandard'
              color='$nonInteractiveAuxiliar'
              aria-hidden
            >
              {' '}
              CEP {place.address?.postalCode} - {place.address?.city}, {place.address?.state}
            </ResponsiveFloraTypography>
          </Flex>
        </Flex>
        <FloraButton
          onClick={handleCopy(place.fullAddress ?? '')}
          hierarchy='secondary'
          has='iconLeft'
          icon={<TwoPiledSquaresIcon />}
          size='small'
          autotagging-flora='on'
          data-flora-text='copiar-endereco'
        >
          <ResponsiveFloraTypography fontWeight='medium' fontSize='bodySmallStandard'>
            Copiar endereço
          </ResponsiveFloraTypography>
        </FloraButton>
      </Styles.CardWrapper>
    </Styles.Card>
  );
};
